import { subclass, property, aliasOf } from "@arcgis/core/core/accessorSupport/decorators";

import Widget from "@arcgis/core/widgets/Widget";
import t9nAppMessages from "../../t9n/App/App.json";

import { messageBundle, tsx } from "@arcgis/core/widgets/support/widget";
import Collection from '@arcgis/core/core/Collection';

import "./FilterChips/FilterChips.scss";
import FilterChipsViewModel from './FilterChips/FilterChipsViewModel';

export type filterType = "capability" | "category";

export interface IChipState {
  guid: string,
  text: string,
  filterType: filterType
};

@subclass("Landing.widgets.FilterChips")
export default class FilterChips extends (Widget) {

  //--------------------------------------------------------------------------
  //
  //  Properties
  //
  //--------------------------------------------------------------------------

  @property()
  viewModel: FilterChipsViewModel = new FilterChipsViewModel();

  @property()
  @aliasOf("viewModel.chips")
  chips: __esri.Collection<IChipState> = new Collection();

  /** This is a ref from NavbarVM */
  @property()
  filterByList: __esri.Collection<string>;

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof t9nAppMessages;

  //--------------------------------------------------------------------------
  //
  //  Lifecycle Methods
  //
  //--------------------------------------------------------------------------

  render() {
    const chipsToRender = this.chips?.map((chip) => { return this._renderChip(chip) }).toArray();
    return (
      <div class="filter-chips">
        {
          chipsToRender
        }
      </div>
    );
  }

  //--------------------------------------------------------------------------
  //
  //  Private Methods
  //
  //--------------------------------------------------------------------------
  private _renderChip(chip: IChipState) {
    return (
      <calcite-chip
        key={`capability-chip-${chip.text}`}
        scale="m"
        appearance="solid"
        color="grey"

        // NOTE: calcite deprecation of dismissible is buggy - this will likely chg post beta-97
        // closeable={true}
        dismissible={true}
        
        afterCreate={(chipDOM: HTMLCalciteChipElement) => {
          chipDOM.addEventListener("calciteChipDismiss", () => {
            const chipToDismiss = this.chips.find((testChip)=>{
              return chip.text === testChip.text && chip.filterType === testChip.filterType;
            });
            if(chipToDismiss){
              this._handleDismiss(chipToDismiss);
            }
          });
        }}
      >
        {this.appMessages.filterChips[chip.filterType]}: { chip.text }
      </calcite-chip>
    );
  }

  private _handleDismiss(chipToDismiss: IChipState) {
    // NOTE: calcite deprecation of dismissible is buggy - this will likely chg post beta-97
    this.filterByList.remove(chipToDismiss.text);
    setTimeout(()=>{
      const foundChip = this.chips.find(chip => chip.guid === chipToDismiss.guid);
      this.chips.remove(foundChip);
    }, 500)
  }

}